import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=6c1858e6&scoped=true"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"
import style0 from "./Create.vue?vue&type=style&index=0&id=6c1858e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1858e6",
  null
  
)

export default component.exports